export default "__VITE_ASSET__DH6wpb$d__"